import { render } from "./StatsDisplay.vue?vue&type=template&id=70e540ef&scoped=true"
import script from "./StatsDisplay.vue?vue&type=script&lang=js"
export * from "./StatsDisplay.vue?vue&type=script&lang=js"

import "./StatsDisplay.vue?vue&type=style&index=0&id=70e540ef&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Keith\\Dropbox\\WebStorm\\Projects\\slumbernot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e540ef"]])

export default __exports__